import React, {useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {ViewMatchedInvoicesForm} from './ViewMatchedInvoicesForm';
import {MatchedInvoicesRow} from '../../types';

interface PopupViewMatchesProps extends MatchedInvoicesRow {}

const PopupViewMatches = (props: PopupViewMatchesProps) => {
  const {formatMessage} = useIntl();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  return (
    <>
      <Button
        className={'btn btn-icon btn-light btn-sm custom-action-button'}
        title={formatMessage({id: 'bankStatements-matchedInvoices-popup-tooltip', defaultMessage: 'View matches'})}
        onClick={handleShowModal}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Search_brandColor.svg')}
          alt="view"
        />
      </Button>
      <Modal
        show={show}
        onHide={handleCloseModal}
        className={'popupMatchInvoicesContainer'}
      >
        <Modal.Body>
          <ViewMatchedInvoicesForm
            closeModal={handleCloseModal}
            {...props}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupViewMatches;
